/*eslint-disable */

import { bus } from '@/main';

export default {
  name: 'pahs-banner-info',
  components: {},
  props: [],
  data () {
    return {
      actvSlide:false
    }
  },
  computed: {

  },
  mounted () {
    setTimeout(() => {
      this.actvSlide = true
    }, 800)
  },
  methods: {
    movingSlideMethod(){
      bus.$emit('movingSlideStateBus', 3)
    }
  }
}


